import { toast } from "sonner";
import { Copy } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";

// Shows freshly-generated plaintext passwords exactly once — this is the
// only moment they're ever visible again after creation/reset, since bcrypt
// hashes can't be read back. Used both for bulk doctor-login creation and a
// single user's "generate new password" action.
export default function GeneratedCredentialsModal({ open, onOpenChange, credentials = [] }) {
  const copy = (text) => {
    navigator.clipboard.writeText(text);
    toast.success("Copied to clipboard.");
  };

  const copyAll = () => {
    const text = credentials.map((c) => `${c.name}\t${c.email}\t${c.password}`).join("\n");
    navigator.clipboard.writeText(text);
    toast.success("All credentials copied.");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>New login credentials</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-muted-foreground">
          Save these now — passwords can't be viewed again after you close this. Share each securely with the person concerned.
        </p>
        <div className="max-h-80 space-y-2 overflow-y-auto">
          {credentials.map((c) => (
            <div key={c.email} className="rounded-md border border-border p-3 text-sm">
              <p className="font-medium">{c.name}</p>
              <div className="mt-1 flex items-center justify-between gap-2">
                <span className="truncate text-muted-foreground">{c.email}</span>
              </div>
              <div className="mt-1 flex items-center justify-between gap-2">
                <code className="rounded bg-muted px-1.5 py-0.5">{c.password}</code>
                <Button type="button" size="sm" variant="outline" onClick={() => copy(`${c.email} / ${c.password}`)}>
                  <Copy className="h-3.5 w-3.5" /> Copy
                </Button>
              </div>
            </div>
          ))}
          {credentials.length === 0 && (
            <p className="py-6 text-center text-sm text-muted-foreground">Nothing to show.</p>
          )}
        </div>
        <DialogFooter>
          {credentials.length > 1 && (
            <Button type="button" variant="outline" onClick={copyAll}>
              Copy all
            </Button>
          )}
          <Button type="button" onClick={() => onOpenChange(false)}>
            Done
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
